import api from './api';

// Personal access tokens for the Figma design plugin.
//
// The plugin is imported by every designer, so it can hold no secret of its own: each designer
// mints a token here, where they are already logged in, and pastes it into the plugin. The
// plaintext comes back exactly once — from then on the server holds only a salted hash.
export const figmaTokenAPI = {
  list: () => api.get('/api/figma-tokens'),
  create: (body) => api.post('/api/figma-tokens', body),
  revoke: (id) => api.delete(`/api/figma-tokens/${id}`),
};

export default figmaTokenAPI;
